import PropTypes from 'prop-types';

// TODO: This appears to be redundant and not needed.
//       This whole component could be integrated into the main Card component.
const CardImage = ({ children, ...rest }) => (
  <div className="overflow-hidden card-image-block" {...rest}>
    {children}
  </div>
);

CardImage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CardImage;
